import { ContainerModule } from 'inversify';
import { domainModule } from './modules/domainModule';
import { messageManagerModule } from '@/dataroom/app/DI/modules/messageManagerModule';
import { analyticsModule } from '@/dataroom/app/DI/modules/analyticsModule';
import { DispatcherModule as UsersDispatcherModule } from '@users/json-rpc-dispatcher';
import { DispatcherModule } from '@dataroom/json-rpc-dispatcher';
import { DispatcherModule as CondorDispatcherModule } from '@condor/json-rpc-dispatcher';
import { DispatcherModule as DmPortalDispatcherModule } from '@dm-portal/json-rpc-dispatcher';
import { DmPortalDmPortalDispatcherModule } from '@dm-portal/dm-portal-json-rpc-dispatcher';
import { FileUploadModule } from './FileUpload/FileUploadDispatcher/fileUploadModule';
import { MultipartFileUploadModule } from './FileUpload/MultipartFileUploadDispatcher/multipartFileUploadModule';
import { FormDataFileUploadModule } from './FileUpload/FormDataFileUploadDispatcher/formDataFileUploadModule';
import { BulkQuestionsModule } from './FileUpload/BulkQuestionUploadDispatcher/bulkQuestionsModule';
import { UsersUploadDispatcherModule } from './FileUpload/UsersUploadDispatcher/usersUploadModule';
import { LogoUploadDispatcherModule } from '@dataroom/logo-upload-dispatcher';
import { SocketModule } from '@dataroom/socket-client';
import { serverCookiesModule, clientCookiesModule } from '@framework/config/DI/cookiesModule';
import { serverReqClientDataModule, clientReqClientDataModule } from '@framework/config/DI/reqClientDataModule';
import { ICookies } from '@framework/router/Next/cookie/ClientCookie';
import { IClientReqData } from '@framework/router/Next/headers/ClientReqData';

interface IData {
  cookie: ICookies,
  headers: IClientReqData,
}

export const rootModules: ContainerModule[] = [
  domainModule,
  messageManagerModule,
  analyticsModule,
  FileUploadModule,
  MultipartFileUploadModule,
  FormDataFileUploadModule,
  BulkQuestionsModule,
  UsersUploadDispatcherModule,
  LogoUploadDispatcherModule,
  UsersDispatcherModule,
  DispatcherModule,
  DmPortalDispatcherModule,
  CondorDispatcherModule,
  DmPortalDmPortalDispatcherModule,
  SocketModule,
];

export const clientContainerModules = ({ cookie, headers }: IData): ContainerModule[] => ([
  ...rootModules,
  clientCookiesModule(cookie),
  clientReqClientDataModule(headers),
]);

export const serverContainerModules: ContainerModule[] = [
  ...rootModules,
  serverCookiesModule,
  serverReqClientDataModule,
];
